import React, {useState} from 'react'

import './styles/navigation.scss'

interface Props {
    links: Array<any>,
    defaultActiveLink?: string,
    update: (key:string) => void
}

function Navigation({links, defaultActiveLink, update}: Props) {
    const [activeLink, setActiveLink] = useState<string>(defaultActiveLink || '')

    const handleClick = (link) => {
        if(link.isDisabled) {
            return;
        }

        setActiveLink(link.key)
        update(link.key)
    }

    const getClasses = (link) => {
        const classesBase = '';
        const classesDisabled = link.isDisabled ? 'disabled' : ''

        return `${classesBase} ${classesDisabled}`;
    }

    return (
        <nav className="navigation">
            {
                links.map((link) => {
                    return (
                        <a key={link.key} className={activeLink === link.key ? `active ${getClasses(link)}` : getClasses(link)} onClick={() => handleClick(link)}>
                            {link.name}
                        </a>
                    )
                })
            }
        </nav>
    )
}

export default Navigation